<template>
    <div class="relative">
        <select class="form-control form-control-sm form-control-fixed bg-white mr-0 sm:mr-1 mb-1 sm:mb-0" v-model="modelCategory" aria-label="Select Category">
            <option v-for="option in categories" :class="{ 'bg-yellow-200': option.highlight }" :value="option.value" :key="option.value">
                {{ option.label }}
            </option>
        </select>
        <select class="form-control form-control-sm form-control-fixed bg-white mr-0 sm:mr-1 mb-1 sm:mb-0" v-model="modelCommodity" aria-label="Select Commodity">
            <option v-for="option in commodities" :class="{ 'bg-yellow-200': option.highlight }" :value="option.value" :key="option.value">
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script setup>
import { ref, watch, watchEffect, computed, onMounted } from 'vue';

const props = defineProps({
    groupings: {
        type: Object,
        required: true
    },
    original: {
        type: Object,
        default: () => ({})
    },
    modelValue: {
        type: [String, Object],
        default: null, // You can set a default value if necessary
    },
});

const emit = defineEmits();

const modelCategory = ref(props.modelValue?.category || '');
const modelCommodity = ref(props.modelValue?.commodity || '');

const root = computed(() => {
    if (modelCategory.value && modelCommodity.value) {
        if (props.groupings[modelCategory?.value][modelCommodity?.value]) {
            return props.groupings[modelCategory?.value][modelCommodity?.value][0].symbolRoot;
        }
    }
});

const categories = computed(() => {
    return Object.keys(props.groupings).map(key => ({
        label: key,
        value: key,
        default: key === props.original['category']
    }));
});

const commodities = computed(() => {
    const categoryContracts = props.groupings[modelCategory.value];
    if (categoryContracts) {
        return Object.keys(categoryContracts).map(key => ({
            label: key,
            value: key,
            default: key === props.original['commodity']
        }));
    }
    return [];
});

watchEffect(() => {
    emit('update:modelValue', {
        root: root.value,
        commodity: modelCommodity.value
    });
});

watch(() => props.original, (neworiginal) => {
    modelCategory.value = neworiginal.category ?? categories.value[0]?.value;
    modelCommodity.value = neworiginal.commodity ?? commodities.value[0]?.value;
}, { immediate: true });

watch(modelCategory, (newCategory) => {
    if (newCategory) {
        modelCommodity.value = commodities.value[0]?.value ?? '';
    }
});

onMounted(() => {
    if (!props.original.contract) {
        emit('update:modelValue', {
            root: root.value,
            commodity: modelCommodity.value
        });
    }

    /**
     * We need to emit when the original is actually the default
     *
     * When on a page like: options/history/ZCN9|275P
     *
     * Our watcher above will not fire
     */
    if (props.original.commodity === 'Corn') {
        emit('update:modelValue', {
            root: root.value,
            commodity: modelCommodity.value
        });
    }
});
</script>
